import { createSlice } from '@reduxjs/toolkit';

import { useAppDispatch } from '@shared/hooks';

import { useAppSelector } from '@src/library/hooks/common';

const initialState = {
	message: {
		text: '',
		html: '',
	},
};

export const modalCopyMessage = createSlice({
	name: 'modalCopyMessage',
	initialState,
	reducers: {
		toggleMessage: (state, action) => {
			state.message = action.payload;
		},
	},
});

const { toggleMessage } = modalCopyMessage.actions;

export const useModalCopyMessage = () => {
	const dispatch = useAppDispatch();

	const message = useAppSelector((state) => state.commonFeatures.modalCopyMessage.message);

	const toggleCopyModal = (message?: { text: string; html: string }) =>
		dispatch(toggleMessage(message));

	return {
		toggleCopyModal,
		message,
	};
};
